import { render, staticRenderFns } from "./customSelfDetail.vue?vue&type=template&id=a87ce5cc&"
import script from "./customSelfDetail.vue?vue&type=script&lang=ts&"
export * from "./customSelfDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports